import KpiCard from "@/components/base/KpiCard";
import BarChart from "@/components/feature/BarChart";
import SectionCard from "./SectionCard";
import { teamKpis, teamPerformance, teamTasksChart } from "@/mocks/salesReports";

export default function TeamTab() {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {teamKpis.map((k) => (
          <KpiCard key={k.label} {...k} />
        ))}
      </div>

      <SectionCard title="أداء الفريق">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[720px] text-sm">
            <thead>
              <tr className="text-xs font-semibold text-ghasla-text-secondary">
                <th className="h-11 px-3 text-right">الفني / الفريق</th>
                <th className="h-11 px-3 text-right">المهام المكتملة</th>
                <th className="h-11 px-3 text-right">التقييم</th>
                <th className="h-11 px-3 text-right">متوسط الوقت</th>
                <th className="h-11 px-3 text-right">نسبة القبول</th>
                <th className="h-11 px-3 text-right">الحالة</th>
              </tr>
            </thead>
            <tbody>
              {teamPerformance.map((t) => (
                <tr key={t.name} className="border-t border-[#F4F8F8] hover:bg-[#FAFEFE]">
                  <td className="h-12 px-3 font-medium text-ghasla-text-heading">{t.name}</td>
                  <td className="h-12 px-3 text-ghasla-text-primary">{t.tasks}</td>
                  <td className="h-12 px-3 text-[#F59E0B]">{t.rating}</td>
                  <td className="h-12 px-3 text-ghasla-text-primary">{t.avgTime}</td>
                  <td className="h-12 px-3 text-ghasla-text-primary">{t.accept}</td>
                  <td className="h-12 px-3">
                    <span
                      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${
                        t.statusTone === "green"
                          ? "bg-[#E9F9F0] text-[#27AE60]"
                          : "bg-[#FEF6E7] text-[#D98B0B]"
                      }`}
                    >
                      {t.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SectionCard>

      <SectionCard title="المهام المكتملة لكل فني — هذا الشهر">
        <BarChart data={teamTasksChart} color="#00AAB7" valueSuffix=" مهمة" height={280} />
      </SectionCard>
    </div>
  );
}